// The /login screen's client-state machine, enumerable for the dev preview
// (see @/dev/preview). LoginClient renders one of these six visual states; only
// the first four are reachable by URL in normal use (they're plain client state),
// so the dev preview (?preview=1&mode=<state>) forces each one so /dev and the
// screen-map can see every state without registering/authenticating for real.
// Plain shared module (no "use client", no server-only) — imported by the server
// page, the client component, and the /dev hub.

export const AUTH_PREVIEW_STATES = [
  "welcome",
  "login",
  "register",
  "recover",
  "codes",
  "signed-in",
] as const;

export type AuthPreviewState = (typeof AUTH_PREVIEW_STATES)[number];

export function parseAuthPreviewState(
  raw: string | string[] | undefined,
): AuthPreviewState | undefined {
  const v = Array.isArray(raw) ? raw[0] : raw;
  return AUTH_PREVIEW_STATES.includes(v as AuthPreviewState)
    ? (v as AuthPreviewState)
    : undefined;
}
